import React from 'react'

export const NotFoundPage = () =>
    <div>
        PAGE NOT FOUND
    </div>